import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import AIEvaluationReportWidget from '../../../widgets/aiEvaluation/AIEvaluationReportWidget'
import { getAiEvaluationReportPage } from '../../../redux/actions/aiEvaluation'

export default function AIEvaluationReportPage() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const pageNumber = 1
  const pageSize = 25

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAiEvaluationReportPage(pageNumber, pageSize)

      if (response) {
        setSchema(response)
      } else {
        setError({})
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isReport>
      <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

      <AIEvaluationReportWidget schema={schema} pageNum={pageNumber} pageSize={pageSize} />

      <br />
    </SidebarProposal>
  )
}
